const productSituation = Object.freeze({
  ATIVO: 'ATIVO',
  GANHO: 'GANHO',
  PERDIDO: 'PERDIDO'
})

export default productSituation



// WEBPACK FOOTER //
// ./src/enums/enumProductSituation.js